// authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("token") || null,
  username: localStorage.getItem("username") || null,
  is_admin: localStorage.getItem("is_admin") === "true" || false,
  expires_at: Number(localStorage.getItem("expires_at")) || null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.username = action.payload.username;
      state.is_admin = action.payload.is_admin;
      state.expires_at = action.payload.expires_at || null;
    },
    logout: (state) => {
      state.token = null;
      state.username = null;
      state.is_admin = false;
      state.expires_at = null;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { login, logout, setToken } = authSlice.actions;
export default authSlice.reducer;
